export default "__VITE_ASSET__8e7964df__"